import "./loader.scss";

const Loader = () => {
  return (
    <div className="loader">{/* <img src={Logo} alt="jsa agri Logo" /> */}</div>
  );
};

export default Loader;
